import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Utils } from 'Utils/utils';
import 'Styles/personalisedOnboarding/_onboardingFloater.scss';
import { ReactComponent as LeftArrow } from 'Assets/svg/left-arrow.svg';
import { ReactComponent as LightBulbIcon } from 'Assets/svg/lightbulb-inverted.svg';
import { ReactComponent as GuideArrorwIcon } from 'Assets/svg/guide-arrow.svg';

import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import * as CONSTANTS from 'Utils/constants';
import { OnboardingStepOnePopup } from 'Components/personalisedOnboarding/onboardingStepOnePopup';
import { OnboardingStepsPopup } from './onboardingStepsPopup';
import { OnboardingStepTwoPopup } from './onboardingStepTwoPopup';
import { OnboardingStepThreePopup } from './onboardingStepThreePopup';
import { OnboardingSingleContactPopup } from './onboardingSingleContactPopup';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const {
  INITIAL_GUIDE_FLOW,
  STARTER_FLOW,
  EMAIL_CAMPAIGN_LIST,
  AD_AUDIENCE_LIST,
  TARGETED_ACCOUNTS,
  SINGLE_CONTACT_ONLY,
} = PERSONALIED_ONBOARDING_FLOWS;
const { LB_GOAL_POPUP_CLICKED } = MX_PERSONALISED_ONBOARDING_EVENTS;
const OnboardingFloater = observer(props => {
  const {
    isPersonalisedOnboardingFlow,
    onboardingCurrentStep,
    isOnboardingGuideFlow,
  } = personalisedOnboardingState;

  const handleFloaterClick = val => {
    Utils.mixpanelTrack(LB_GOAL_POPUP_CLICKED);
    personalisedOnboardingState.setIsPersonalisedOnboardingFlow(val);
  };

  const handleMaskClick = () => {
    if (
      isPersonalisedOnboardingFlow === INITIAL_GUIDE_FLOW &&
      isOnboardingGuideFlow
    ) {
      personalisedOnboardingState.setIsOnboardingGuideFlow(false);
      personalisedOnboardingState.clearOnboardingFlow();
    }
  };

  useEffect(() => {
    if (Utils.getCookie('show_onboarding_initial_guide') !== null) {
      handleFloaterClick(STARTER_FLOW);
      personalisedOnboardingState.setIsOnboardingGuideFlow(true);
      Utils.deleteCookie('show_onboarding_initial_guide');
    }
  }, []);

  return (
    Utils.checkShowPersonalisedOnboarding() && (
      <>
        {(isPersonalisedOnboardingFlow === null ||
          isPersonalisedOnboardingFlow === INITIAL_GUIDE_FLOW) && (
          <div
            className="onboarding-floater"
            onClick={() => handleFloaterClick(STARTER_FLOW)}
          >
            {/* <LeftArrow className="onb-arrow-icon" />
            <LeftArrow className="onb-arrow-icon right-arrow" /> */}
            <LightBulbIcon className="onb-bulb-icon" />
          </div>
        )}
        {isPersonalisedOnboardingFlow === INITIAL_GUIDE_FLOW && (
          <div className="onboarding-initial-guide">
            <div className="info-wrapper">
              <div className="title">Goal Navigator rests here</div>
              <div className="description">
                Click here to use the Goal Navigator
              </div>
            </div>
            <div className="guide-arrow-wrapper">
              <GuideArrorwIcon />
            </div>
          </div>
        )}
        {isPersonalisedOnboardingFlow !== null && (
          <div
            className="onboarding-backdrop"
            onClick={e => handleMaskClick()}
          />
        )}
        {isPersonalisedOnboardingFlow === STARTER_FLOW && (
          <OnboardingStepsPopup {...props} />
        )}
        {isPersonalisedOnboardingFlow === SINGLE_CONTACT_ONLY && (
          <OnboardingSingleContactPopup {...props} />
        )}

        {(isPersonalisedOnboardingFlow === EMAIL_CAMPAIGN_LIST ||
          isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ||
          isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST) &&
          onboardingCurrentStep === 1 && <OnboardingStepOnePopup />}
        {(isPersonalisedOnboardingFlow === EMAIL_CAMPAIGN_LIST ||
          isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ||
          isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST) &&
          onboardingCurrentStep === 2 && <OnboardingStepTwoPopup />}
        {(isPersonalisedOnboardingFlow === EMAIL_CAMPAIGN_LIST ||
          isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ||
          isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST) &&
          onboardingCurrentStep === 3 && <OnboardingStepThreePopup />}
      </>
    )
  );
});

export default withRouter(OnboardingFloater);
